module.exports = __webpack_public_path__ + "assets/img/j-i7.b2f0a451.png";